import styled from 'styled-components';
import {Space} from 'antd';

const StyledInvoiceNavigationButtons = styled.div`
  align-items: start;
  display: flex;
  justify-content: space-between;

  .ant-btn {
    align-items: center;
    display: inline-flex;
    font-size: 14px;
    justify-content: center;
    height: 34px;

    &.ant-dropdown-trigger {
      height: 32px;
    }

    &:not(.ant-btn-primary) {
      color: ${props => props.theme.colors.neutral_10};
    }

    &.ant-btn-primary {
      svg {
        path, rect {
          fill: ${props => props.theme.colors.neutral_1};
        }
      }
    }

    &[iconposition="end"] {
      flex-direction: row-reverse;

      .ant-btn-icon {
        margin-inline-start: 8px;
        margin-inline-end: 0;
      }
    }

    &:not(.ant-btn-dangerous):not(:disabled):not(.ant-btn-disabled):not(.ant-btn-primary) {
      &:hover {
        svg {
          path {
            fill: ${props => props.theme.colors.primary_8};
            stroke: ${props => props.theme.colors.primary_8};
          }
        }
      }
    }

    &.ant-btn-default:not(:disabled):not(.ant-btn-disabled):active,
    &.ant-btn-default:not(:disabled):not(.ant-btn-disabled):focus {
      box-shadow: none;

      &.ant-btn-default {
        border-color: ${props => props.theme.colors.status_grey};
      }
    }

    &:disabled,
    &.ant-btn-disabled {
      color: ${props => props.theme.colors.neutral_6};
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_6};
          stroke: ${props => props.theme.colors.neutral_6};
        }
      }
    }

    &.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled) {
      border-color: ${props => props.theme.colors.neutral_5};
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_6};
        }
      }

      &:active,
      &:focus,
      &:hover {
        svg {
          path {
            fill: ${props => props.theme.colors.functional_danger};
          }
        }
      }
    }

    &.ant-btn-dangerous {
      &:disabled,
      &.ant-btn-disabled {
        svg {
          path {
            stroke: transparent;
          }
        }
      }
    }

    &.ant-btn-primary {
      svg {
        path, rect {
          fill: ${props => props.theme.colors.neutral_1};
        }
      }
      &:disabled,
      &.ant-btn-disabled {
        svg {
          path, rect {
            fill: ${props => props.theme.colors.neutral_5};
          }
        }
      }
    }

    svg {
      height: 16px;
      transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 16px;

      & > * {
        transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }
  }
`;

const StyledInvoiceNavigationButtonsSpace = styled(Space)`
  width: 100%;
  justify-content: end;
`;

export {
  StyledInvoiceNavigationButtons,
  StyledInvoiceNavigationButtonsSpace,
}
